/**
 * Replaces literal escape sequences in agent messages with actual characters
 * so react-markdown renders them correctly.
 *
 * Handles: \n, \\n → newline | \t, \\t → tab | \<whitespace> → newline
 * The trailing-backslash rule catches broken LLM escapes where \n was split
 * across chunks or the "n" was dropped (e.g. "Research**\ our").
 *
 * Preserves content inside fenced code blocks and inline code spans.
 */
const CODE_BLOCK_OR_INLINE = /(```[\s\S]*?```|`[^`]*`)/g

const ESCAPE_SEQUENCE = /\\{1,2}([nt])/g
const TRAILING_BACKSLASH = /\\(?=\s)/g

const ESCAPE_MAP: Record<string, string> = { n: '\n', t: '\t' }

const replaceEscapes = (text: string): string =>
  text
    .replace(ESCAPE_SEQUENCE, (_, char: string) => ESCAPE_MAP[char])
    .replace(TRAILING_BACKSLASH, '\n')

export const sanitizeAgentMessage = (content: string): string => {
  if (!content.includes('\\')) {
    return content
  }

  const parts = content.split(CODE_BLOCK_OR_INLINE)

  for (let i = 0; i < parts.length; i++) {
    if (i % 2 === 0) {
      parts[i] = replaceEscapes(parts[i])
    }
  }

  return parts.join('')
}
